'use strict';

module.exports = require('./personal_data_keys');
